//MUI
import { Box, IconButton, Link, Menu, Stack } from "@mui/material"

import MenuIcon from '@mui/icons-material/Menu';

//NEXT
import Image from "next/image";
import { useRouter } from "next/router";

//REDUX
import { useSelector } from "react-redux";
//CONFIG
import { customComponentTypes } from "../../customComponents/types";
import CustomComponent from '../../customComponents/CustomComponent';

//CUSTOM HOOKS
import useResponsive from "../../hooks/useResponsive";
import { useState } from "react";
import { devices } from "../../config/config";
import EkhoolImage from "../ekhoolImage/ekhoolImage";
import AppLogo from "../logo/Logo";

// <---------------------------------------------------------> 

//COMPONENT KEY
const key = 'header3'

// <---------------------------------------------------------> 

const Header3 = ({ editable }) => {

    //STATE
    const [openDrawer, setOpenDrawer] = useState(false);
    const [anchorElNav, setAnchorElNav] = useState(null);

    //HOOKS
    const { reducer }   = useSelector((state) => state);
    const isDesktop     = useResponsive('up', 'lg');
    const { push }      = useRouter();

    //REDUCER - REDUX
    const { pageJson, appData, user, device } = reducer;

    //SITE BUILDER
    const themeJson = pageJson?.components?.filter((i) => (i.key === key));
    const themeItem = themeJson?.length > 0 && themeJson[0];
    const style = themeItem && themeItem?.style ? themeItem.style : {};


    const handleOpenNavMenu = (event) => {
      setAnchorElNav(event.currentTarget);
    };

    const handleCloseNavMenu = () => {
      setAnchorElNav(null);
    };     

    //VARIABLES
    const loggedIn = user !== null
    const isMobile = device === devices.MOBILE;

    return (
        <Stack minHeight={60} width={editable ? '100%' : '80%'} px={2} style={style} justifyContent={'center'} zIndex={99999999999} top={0} >

            <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>

                <IconButton
                    size="large"
                    aria-label="account of current user"
                    aria-controls="menu-appbar"
                    aria-haspopup="true"
                    onClick={() => { setOpenDrawer(!openDrawer) }}
                    color="inherit"
                >

                    <MenuIcon />

                </IconButton>

                    <Menu
                        id="menu-appbar"
                        anchorEl={anchorElNav}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'left',
                        }}
                        keepMounted
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'left',
                        }}
                        open={Boolean(anchorElNav)}
                        onClose={handleCloseNavMenu}
                        sx={{
                            display: { xs: 'block', md: 'none' },
                        }}
                    >            

                    {
                    themeItem?.children?.map((item, index) => {
                        return (
                        <CustomComponent item={item} type={item.type} {...item.props} index={index} >
                            {item.children}
                        </CustomComponent>
                        )
                    })
                    }             

                </Menu>          

          </Box>

            <Stack direction={{xl:'row', md:'row'}} px={0} display={{xs:'none', md:'flex'}} alignItems={'center'} justifyContent={'space-between'} height={'100%'} >

                <Box height={'100%'} width={150} position={'relative'} onClick={() => { push('/') }}  sx={{ cursor: 'pointer' }}  >

                    {
                        appData &&
                        <AppLogo/>
                    }
                    
                </Box>
                
                {
                    isDesktop &&                   
                        <Stack direction={'row'} gap={2} alignItems={'center'} p={2}>
                            {
                                themeItem?.children?.filter((i) => (i.type !== customComponentTypes.image))?.map((item, index) => {
                                    return (
                                        <CustomComponent {...item.props} type={item?.type} item={item} index={index} >
                                            {item?.children}
                                        </CustomComponent>
                                    )
                                })
                            }
                        </Stack>                   
                }

            </Stack>

        </Stack>
    )
};

export default Header3;